import {
    Message
} from 'element-ui'
import router from '../router'

export default {
    // 手机号验证
    checkPhone(phone) {
        // 中国大陆手机号正则：1开头，第二位 3-9，总共 11 位
        const reg = /^1[3-9]\d{9}$/

        if (!phone) {
            return {
                valid: false,
                msg: '请输入手机号'
            }
        }
        if (phone.length !== 11) {
            return {
                valid: false,
                msg: '手机号必须是11位'
            }
        }
        if (!reg.test(phone)) {
            return {
                valid: false,
                msg: '手机号格式不正确'
            }
        }
        return {
            valid: true,
            msg: '校验通过'
        }
    },
    // 提示
    showMsg(type, msg, duration, callback) {
        Message({
            type: type,
            message: msg,
            duration: duration || 2000,
            onClose: () => {
                // 提示框关闭后执行回调
                if (callback && typeof callback === 'function') {
                    callback()
                }
            }
        })
    },
    // 跳转页面
    goPage(path) {
        router.push(path)
        // 滚动到页面顶部
        window.scrollTo(0, 0);
    },

    // 图片拼接
    formatImgUrl(url) {
        let imgUrl = "https://static.runxinai.com/material/" + url
        return imgUrl
    }
}